import { Injectable } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Subject } from 'rxjs';
import { take } from 'rxjs/operators'
import { ConsultClientService } from './consult-client.service';

export enum STEPPER_LIMITATIONS {
  STEPS_LIMITED = 'limited',
  STEPS_WITHDRAWAL = 'withdrawal',
  STEPS_WITHDRAWAL_LIMITED = 'withdrawal-limited',
}

@Injectable({
  providedIn: 'root'
})
export class SuggestingService {

  public constructor(
    private route: ActivatedRoute,
    private consultClientService: ConsultClientService,
  ) {}

  private _stepsLimitedSubject = new Subject<STEPPER_LIMITATIONS | false>();
  public stepsLimited = this._stepsLimitedSubject.asObservable();

  public setStepsLimitedIfPresent(): void {
    this.route.queryParamMap.pipe(take(1)).subscribe((params: ParamMap) => {
      this._stepsLimitedSubject.next(params.get('steps') as STEPPER_LIMITATIONS)
    });
  }

  public resetStepsLimited(): void {
    this.consultClientService.clearNewClient();
    this._stepsLimitedSubject.next(false);
  }
}
